import { AuditResponse, MediaPlan, MediaPlanResponse } from '@/api/data-contracts';
import useUploadProgressService from '@/shared/api/uploadProgress.service';

import { MediaPlanVersionRow, MediaPlanVersions } from './MediaPlanVersions';

const useMediaPlanVersionsService = () => {
  const versionsApi = useUploadProgressService(MediaPlanVersions);

  const duplicateMediaPlanAsVersion = async (
    sourcePlanId: string,
    request: MediaPlan,
    versionNumber?: number,
  ): Promise<MediaPlanResponse> => {
    const { data } = await versionsApi.duplicateAsVersion(
      sourcePlanId,
      request,
      versionNumber ? { number: versionNumber } : undefined,
    );
    return data;
  };

  const getMediaPlanVersions = async (
    planId: string,
    signal: AbortSignal | undefined,
  ): Promise<MediaPlanVersionRow[]> => {
    const { data } = await versionsApi.listVersions(planId, { signal });
    return data;
  };

  const getMediaPlanGroupHistory = async (
    planId: string,
    signal?: AbortSignal,
  ): Promise<AuditResponse[]> => {
    const { data } = await versionsApi.groupHistory(planId, { signal });
    return data;
  };

  return {
    duplicateMediaPlanAsVersion,
    getMediaPlanVersions,
    getMediaPlanGroupHistory,
  };
};

export default useMediaPlanVersionsService;
